import startCar from "@services/startCar";
import { alertPopup } from "@utils/popup";
import { Button, Card, Icon, Input, Layout, PageHeader, Select, Spin } from "antd";
import React from "react";

class StartMessages extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchBy: 'name',
            searchValue: '',
            list: [],
            selectedAgentId: '',
            selectedAgent: '',
            loadingSearch: false,
            loading: false,
            openAgentList: false,
            showSuccess: false,

            inputs: {
                subject: '',
                content: '',
                from: ''
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedAgentId != this.state.selectedAgentId) {
            const { list, selectedAgentId } = this.state
            const selectedAgent = list.find((el) => el.id == selectedAgentId)
            this.setState({ selectedAgent })
        }

        if (prevState.list.length != this.state.list.length) {
            const { list, selectedAgentId } = this.state
            if (list.length && !selectedAgentId) this.setState({ openAgentList: true })
        }
    }

    handleSearchInput = (e) => {
        let { value } = e.target
        const { searchBy } = this.state

        if (searchBy == 'phone') {
            value = value.replace(/\D/g, '')
        }
        this.setState({ searchValue: value })
    }

    search = (resetSearch?:boolean) => {
        let { searchBy, searchValue } = this.state
        let payload
        if (searchBy == 'phone') searchValue = searchValue.replace(/^0/, '')

        if (!resetSearch) {
            payload = { page: 1, perPage: 10000, search: { [searchBy]: searchValue } }
        } else {            
            this.setState({ searchBy: 'name', searchValue: '' })
        }
       
        this.setState({ loadingSearch: true, selectedAgent: '', selectedAgentId: '' }, () => {
            startCar.getStartAgents(payload)
            .then((res) => {
                const { data } = res.data.agents
                this.setState({ list: data })
            })
            .catch((error) => {
                console.log('error. search start agents', error.response);
            })
            .finally(() => this.setState({ loadingSearch: false }))
        })
    }

    resetSearch = () => {
        this.setState({ searchBy: 'phone', searchValue: '' }, () => this.search(true))
    }

    handleInputs = (e) => {
        const { value, id } = e.target
        const field = id.substring(0, id.lastIndexOf('_'))
        this.setState({ inputs: { ...this.state.inputs, [field]: value } })
    }

    submit = () => {
        const { inputs, selectedAgentId } = this.state
        const payload = {
            ...inputs,
            agent_id: selectedAgentId
        }
        this.setState({ loading: true }, () => {
            startCar.sendMessage(payload)
            .then((res) => {
                this.resetInputs()

                if (res.status == 200) {
                    this.setState({ showSuccess: true } , () => {
                        setTimeout(() => this.setState({ showSuccess: false }), 2000)
                    })
                } else if ( res.status == 206) {
                    
                    const body = (
                        <div>
                            <h6>נכשלו:</h6>
                            {res.data.fails ? res.data.fails.join(', ') : ''}
                        </div>
                    )
                    alertPopup({ type: 'alert', title: 'ההודעה לא נשלחה לכל כתובות המייל', body })
                }


            })
            .catch((error) => {
                console.log('error. send message', error.response);
                alertPopup({ type: 'error', title: 'אירעה שגיאה', body: 'הפעולה לא בוצעה' })
            })
            .finally(() => this.setState({ loading: false }))
        })
    }

    resetInputs = () => {
        this.setState({
            inputs: {
                subject: '',
                content: '',
                from: ''
            }
        })
    }

    valid = () => {
        const { inputs, selectedAgentId } = this.state
        return (
            selectedAgentId &&
            inputs.subject &&
            inputs.from &&
            inputs.content
        )
    }


    render() {

        const {
            searchBy,
            searchValue,
            list,
            selectedAgentId,
            selectedAgent,
            inputs,
            openAgentList,
            loading,
            showSuccess
        } = this.state

        return (
            <Layout>
                <PageHeader
                    onBack={() => window.history.back()}
                    title={"שליחת הודעה לסוכן"}
                />
                <Card
                    title={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex' }}>
                                <div style={{display: 'flex', alignItems: 'stretch'}}>
                                    <span style={{lineHeight: '1.8', marginLeft: '30px'}}>{"חיפוש לפי:"}</span>
                                    <Select
                                        id="type"
                                        style={{ width: '150px' }}
                                        defaultValue={searchBy}
                                        value={searchBy}
                                        onChange={(value) => this.setState({ searchBy: value, searchValue: '' })}
                                    >
                                        <Select.Option value={'name'}>{'שם'}</Select.Option>
                                        <Select.Option value={'phone'}>{'נייד'}</Select.Option>
                                    </Select>
                                </div>
                                <Input 
                                    value={searchValue} 
                                    onChange={this.handleSearchInput}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            this.search(false)
                                        }
                                    }}
                                />
                                <Button style={{ height: '32px' }} onClick={() => this.search(false)}>{"חיפוש"}</Button>
                                {/* <Button style={{ marginRight: '60px' }} onClick={() => this.search(true)} >{"איפוס"}</Button> */}

                                <div style={{ marginRight: '30px' }}>
                                    <Select
                                        id="agent"
                                        style={{ width: '150px' }}
                                        value={selectedAgentId}
                                        onChange={(value) => this.setState({ selectedAgentId: value })}
                                        open={openAgentList}
                                        onDropdownVisibleChange={() => this.setState({ openAgentList: !this.state.openAgentList })}
                                        style={{ width: '280px' }}
                                    >
                                        {list.map((agent, idx) => (
                                            <Select.Option key={idx.toString()} value={agent.id}>
                                                {`${agent.name}`}
                                            </Select.Option>)
                                        )}
                                        
                                    </Select>
                                </div>
                                <Button style={{ marginRight: '30px' }} onClick={() => this.search(true)} >{"איפוס"}</Button>


                            </div>

                        </div>
                    }
                    headStyle={{ backgroundColor: '#dadce0' }}
                    bodyStyle={{ padding: '0.8rem 0.8rem' }}
                    style={{ marginBottom: '1rem' }}
                >

                    <div style={{ ...styles.wrapper }} >
                        
                        <span style={{ ...styles.title }}>
                        {selectedAgentId ?
                            <>
                                <span style={{  }}>{"הודעה עבור סוכן:"}</span>
                                <span style={{ margin: '0 10px' }}>{`${selectedAgent.name}`}</span>
                                <span style={{  }}>{"- נייד:"}</span>
                                <span style={{ margin: '0 10px' }}>{selectedAgent.phone ? `0${selectedAgent.phone}` : ''}</span>
                            </>: ''}
                        </span>
                        <div style={{ ...styles.fieldWrapper }}>
                            
                            <div style={{ display: 'flex', alignSelf: 'stretch' }}>
                                <div style={{ ...styles.label }}>{"נושא"}</div>
                                <Input style={{ ...styles.input }} id={"subject_input"} value={inputs.subject} onChange={this.handleInputs} />
                            </div>
                            <div style={{ display: 'flex', alignSelf: 'stretch' }}>
                                <div style={{ ...styles.label }}>{"שם הלקוח"}</div>
                                <Input id={"from_input"} value={inputs.from} onChange={this.handleInputs} />
                            </div>
                            <Input.TextArea style={{ height: '400px' }} id={"content_input"} value={inputs.content} onChange={this.handleInputs} />
                            
                            <div style={{ ...styles.submitContainer }}>
                                <Button
                                    style={{ margin: `0 20px 0 12px` }}
                                    disabled={loading || !this.valid()}
                                    onClick={this.submit}>
                                        {"שליחה"}
                                </Button>
                                {loading ? <Spin /> : <div style={{ width: '20px' }}></div>}
                                {showSuccess ?
                                    <div style={{ ...styles.success }}>
                                        <span style={{ marginLeft: '20px' }}>{"נשלח בהצלחה"}</span>
                                        <Icon type="check" />
                                    </div> : ''}
                            </div>
                        </div>
                    </div>

                </Card>
            </Layout>
        )
    }
}

const styles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column'
    },
    title: {
        fontSize: '24px',
        height: '46px'
    },
    fieldWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '580px',
    },
    input: { borderRadius: '3px 0 0 3px' },
    label: {
        borderRadius: '0 3px 3px 0',
        background: 'white',
        border: 'solid #d1d1d1 1px',
        width: '90px',
        height: '32px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    success: {
        display: 'flex',
        fontSize: '20px',
        color: '#5bd93b',
        alignItems: 'baseline',
        position: 'absolute',
        left: '80px'
    },
    submitContainer: {
        alignSelf: 'stretch',
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '26px',
        position: 'relative'
    }
}

export default StartMessages